import { Component, OnInit } from '@angular/core';

import { AngularFireDatabase} from 'angularfire2/database';
import { Observable } from 'rxjs/Observable';

import "rxjs/add/operator/map";
import { Router } from '@angular/router';


@Component({
  selector: 'app-overview',
  templateUrl: './overview.component.html',
  styleUrls: ['./overview.component.css']
})
export class OverviewComponent implements OnInit {

  items: Observable<any[]>;

  constructor(db: AngularFireDatabase, public router: Router) {
      this.items = db.list('/study_spot', ref => ref.orderByChild('name')).valueChanges();
  }

  cli(obj) {
    console.log(obj);
    var id:String = obj;
    this.router.navigate(['/home/spotDetail', id]);
  }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/overview/overview.component.ts